export default "__VITE_ASSET__CsxX73tk__"